import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../utils";

type BodyElement = "p" | "span" | "div";

const bodyVariants = cva("m-0 tracking-normal", {
  variants: {
    bold: {
      true: "font-semibold",
      false: "font-normal"
    },
    size: {
      xl: "text-xl leading-7",
      lg: "text-lg leading-7",
      md: "text-base leading-6",
      sm: "text-sm leading-5",
      xs: "text-xs leading-4"
    }
  },
  defaultVariants: {
    size: "md",
    bold: false
  }
});

export interface BodyProps
  extends React.HTMLAttributes<HTMLParagraphElement>,
    VariantProps<typeof bodyVariants> {
  bold?: boolean;
  as?: BodyElement;
}

const Body = React.forwardRef<HTMLParagraphElement, BodyProps>(
  ({ className, size, bold, as = "p", ...props }, ref) => {
    const Comp = as;
    return (
      <Comp
        className={cn(bodyVariants({ bold, size, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);
Body.displayName = "Body";

export { Body, bodyVariants };
